function parseEnvironment(environment) {
  if (environment === 'uswest2-devtest01') {
    return 'devtest'
  }

  if (environment === 'useast2-preprod01') {
    return 'preprod'
  }

  if (environment === 'useast1-prod01') {
    return 'production'
  }

  if (environment === 'development') {
    return 'devtest'
  }

  if (environment === 'testing') {
    return 'devtest'
  }

  if (environment === 'local') {
    return 'devtest'
  }

  return 'production'
}

export default parseEnvironment
